import { DAY_OFF_JOB_TYPES } from '@ubeya/shared/constants/timesheet';

export const DISABLE_FILL_HOURS_BY_JOB_TYPE = DAY_OFF_JOB_TYPES;

export const DAILY_EMPLOYEES_SLUG = 'dailyEmployees';

/* sentinel option value of the "No agency" entry in the timesheet agencies filter */
export const NO_AGENCY_FILTER_VALUE = 0;
